import { useSelector } from "react-redux";
// ** Vertical Menu Components
import VerticalNavMenuLink from "./VerticalNavMenuLink";
import VerticalNavMenuGroup from "./VerticalNavMenuGroup";
import VerticalNavMenuSectionHeader from "./VerticalNavMenuSectionHeader";
// ** Utils
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@layouts/utils";
import { CgWorkAlt } from "react-icons/cg";

const VerticalMenuNavItems = (props) => {
  // ** Components Object
  const Components = {
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    VerticalNavMenuSectionHeader,
  };

  //get data from reducer
  const RolesReducer = useSelector((store) => store.RolesReducer);
  //prepare dynamic submenus to render
  const roles_submenus = RolesReducer.roles_by_radio.map((el) => ({
    id: el.id,
    title: el.name.trim(),
    icon: <CgWorkAlt size={20} />,
    navLink: `/admin/stuff/users_by_role/${el.id}`,
    acl: `view-stuff-users-id`,
  }));
  /*search on the index of menus by title */
  const staff_index = props.items?.findIndex(
    (ele) => ele?.id === "view-stuff-users-id"
  );
  /*check if the index is found*/
  if (staff_index > -1) {
    /*affect the submenus on the menu*/
    props.menuData[staff_index].children = roles_submenus;
  }

  const RenderNavItems = props.items.map((item, index) => {
    const TagName = Components[resolveNavItemComponent(item)];

    if (item.header) {
      return <TagName key={item.header} item={item} {...props} />;
    }
    if (item.children) {
      const withChild = item.children.filter((el) =>
        props.hasPermission(el.acl)
      );
      const withTwoChild = item.children.filter((el) =>
        el.children?.some((elss) => props.hasPermission(elss.acl))
      );
      if (
        item.public ||
        props.hasPermission(item.acl) ||
        withChild.length ||
        withTwoChild.length
      ) {
        return <TagName item={item} index={index} key={item.id} {...props} />;
      } else {
        return;
      }
    }
    return (
      (props.hasPermission(item.acl) || item.public) && (
        <TagName key={item.id || item.header} item={item} {...props} />
      )
    );
  });

  return RenderNavItems;
};

export default VerticalMenuNavItems;
